requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: [],
      cachedfetch: [],
      loadingUrls: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      isMiniCart: false,
      buttonQuickView: "",
      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
      },
      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      load(url, el, optionId) {
        this.loading = true;

        requestAnimationFrame(() => {
          setTimeout(() => { 
            if (this.buttonQuickView == '') {
              this.buttonQuickView = el;
            }
            let variant = document.getElementById('current-variant-' + optionId)?.innerText;
            let productUrl = variant?`${url}?variant=${variant}&section_id=${this.sectionId}`:`${url}?section_id=${this.sectionId}`;
            productUrl = productUrl.replace(/\s+/g, '');
            
            if (this.cachedResults[productUrl]) {
              document.getElementById('quickview-product-content').innerHTML = this.cachedResults[productUrl];
              this.selectFirstVisibleVariant(document.getElementById('quickview-product-content'));
              this.loading = false;
              return true;
            }
            
            if (this.cachedfetch[productUrl]) {
              return true;
            }

            this.cachedfetch[productUrl] = true;
            fetch(productUrl)
              .then(reponse => {
                return reponse.text();
              })
              .then((response) => {
                const parser = new DOMParser();
                const content = parser.parseFromString(response,'text/html').getElementById("quickview-product-content").innerHTML;
                document.getElementById('quickview-product-content').innerHTML = content;
                this.cachedResults[productUrl] = content;
                this.selectFirstVisibleVariant(document.getElementById('quickview-product-content'));
                document.dispatchEvent(new CustomEvent("eurus:quickview:loaded", {
                  detail: {
                    productUrl: url
                  }
                }));
              })
              .finally(() => {
                this.loading = false;
                this.cachedfetch[productUrl] = false;
              })

            return true;
          }, 0)
        });
      },
      applyExcludedOptionValues(root, sourceEl) {
        if (!root) return;
        const excludeRaw = sourceEl?.closest('.card-product')?.getAttribute('data-exclude-option-values') || '';
        const excluded = excludeRaw.split(',').map((name) => name.trim().toLowerCase()).filter(Boolean);
        if (!excluded.length) return;

        const matches = (text) => excluded.includes(String(text || '').replace(/\s+/g, ' ').trim().toLowerCase());

        root.querySelectorAll('input[type="radio"]').forEach((input) => {
          if (matches(input.value) || matches(input.getAttribute('aria-label'))) {
            const wrap = input.closest('.relative.inline-flex') || input.parentElement;
            if (wrap) wrap.classList.add('hidden');
            input.checked = false;
            input.disabled = true;
          }
        });

        root.querySelectorAll('select').forEach((select) => {
          Array.from(select.options).forEach((option) => {
            if (option.value && matches(option.value)) option.remove();
          });
        });
        this.selectFirstVisibleVariant(root);
      },
      selectFirstVisibleVariant(root) {
        if (!root) return;

        const radioIsUsable = (input) => {
          if (!input || input.disabled) return false;
          const wrap = input.closest('.relative.inline-flex') || input.parentElement;
          if (wrap && (wrap.classList.contains('hidden') || wrap.hasAttribute('hidden'))) return false;
          return true;
        };

        root.querySelectorAll('fieldset').forEach((fieldset) => {
          const radios = [...fieldset.querySelectorAll('input[type="radio"]')].filter(radioIsUsable);
          if (!radios.length) return;
          if (radios.some((input) => input.checked)) return;
          const next = radios.find((input) => input.dataset.available !== 'false') || radios[0];
          next.checked = true;
          next.dispatchEvent(new Event('change', { bubbles: true }));
        });

        root.querySelectorAll('select.product-form__input, .variant-selects-main select').forEach((select) => {
          const current = select.options[select.selectedIndex];
          if (current && current.value) return;
          const next = [...select.options].find((option) => option.value && !option.disabled);
          if (!next) return;
          next.selected = true;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      },
      async loadChooseOptions(url, el, optionId, index) {
        setTimeout(async () => { 
          let getVariant = document.getElementById('current-variant-' + optionId)?.innerText;
          let urlProduct = `${url}?section_id=choose-option&page=${index}`;
          
          let destinationElm = document.getElementById('choose-options-' + optionId)?.querySelector('.choose-options');
          let destinationElmMobile = document.getElementById('choose-options-mobile');
          let loadingEl = document.getElementById('choose-options-' + optionId)?.querySelector('.icon-loading');
          
          if (this.loadedChooseOptions[urlProduct]) {
            this.loadingChooseOption = false;
            if (window.xViewport.innerWidth > 767) {
              if (!el.closest('.card-product').querySelector('#choose-options-' + optionId)?.querySelector('.choose-options-content')) {
                destinationElm && (destinationElm.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElmMobile && (destinationElmMobile.innerHTML = '');
                this.applyExcludedOptionValues(destinationElm, el);
              }
              if (destinationElm) {
                if (destinationElm.querySelector(".add_to_cart_button")) {
                  destinationElm.querySelector(".add_to_cart_button").style.display="block";
                }
                if (destinationElm.querySelector(".label-btn-quickview")) {
                  destinationElm.querySelector(".label-btn-quickview").style.display="none";
                }
              }
            } else {
              if (!el.closest('.card-product').querySelector('#choose-options-mobile')) {
                destinationElmMobile && (destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElm && (destinationElm.innerHTML = '');
                this.applyExcludedOptionValues(destinationElmMobile, el);
              }
              if (destinationElmMobile) {
                if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                  destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                }
                if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                  destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                }
              }
            }
            return true;
          }
          
          try {
            if (loadingEl) {
              loadingEl.classList.remove('hidden');
            }
            this.loadingChooseOption = true;
            if (!this.loadingUrls.includes(urlProduct)) {
              this.loadingUrls.push(urlProduct);
              await fetch(urlProduct).then((response) => response.text()).then((content) => {
                const parser = new DOMParser();
                const parsedContent = parser.parseFromString(content, 'text/html').getElementById("choose-options-content").innerHTML;
                
                if (parsedContent) {
                  if (window.xViewport.innerWidth > 767) {
                    destinationElmMobile && (destinationElmMobile.innerHTML = '');
                    destinationElm && (destinationElm.innerHTML = parsedContent);
                    this.applyExcludedOptionValues(destinationElm, el);
                  } else {
                    destinationElmMobile && (destinationElmMobile.innerHTML = parsedContent);
                    destinationElm && (destinationElm.innerHTML = '');
                    this.applyExcludedOptionValues(destinationElmMobile, el);
                  }
                  this.loadedChooseOptions[urlProduct] = parsedContent;
                }
                if (loadingEl) {
                  loadingEl.classList.add('hidden');
                }  
              }).finally(() => {
                const index = this.loadingUrls.indexOf(urlProduct);
                if (index !== -1) this.loadingUrls.splice(index, 1);
                this.loadingChooseOption = false;
                if (window.xViewport.innerWidth > 767) {
                  if (destinationElm) {
                    if (destinationElm.querySelector(".add_to_cart_button")) {
                      destinationElm.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElm.querySelector(".label-btn-quickview")) {
                      destinationElm.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                } else {
                  if (destinationElmMobile) {
                    if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                      destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                      destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                }
                document.dispatchEvent(new CustomEvent("eurus:quickview:loaded", {
                  detail: {
                    productUrl: url
                  }
                }));  
              });
            } else {
              this.loadingChooseOption = false;
            }
          } catch (error) {
            console.log(error);
          }
        }, 0)
      },
      open(isMiniCart = false) {
        this.pageScrollY = window.scrollY;
        this.show = true;
        this.isMiniCart = isMiniCart;
        Alpine.store('xPopup').open = true;
        this.bindScrollProxy();
        requestAnimationFrame(() => {
          this.selectFirstVisibleVariant(document.getElementById('quickview-product-content'));
        });
        document.dispatchEvent(new CustomEvent("eurus:quickview:open"));
      },
      close() {
        this.show = false;
        this.buttonQuickView = '';
        this.unbindScrollProxy();
        if(!Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
        if (typeof this.pageScrollY === 'number') {
          window.scrollTo(0, this.pageScrollY);
        }
      },
      preservePageScroll() {
        if (!this.show) return;
        const y = typeof this.pageScrollY === 'number' ? this.pageScrollY : window.scrollY;
        requestAnimationFrame(() => {
          if (Math.abs(window.scrollY - y) > 1) {
            window.scrollTo(0, y);
          }
        });
      },
      getScrollContent() {
        return document.getElementById('QuickViewContent');
      },
      bindScrollProxy() {
        if (this._wheelHandler) return;
        this._wheelHandler = (event) => {
          if (!this.show) return;
          if (!event.target.closest('#QuickView .x-quickview-modal')) return;

          const content = this.getScrollContent();
          if (!content) return;

          const nestedScroller = event.target.closest('#QuickViewContent [style*="overflow"], #QuickViewContent .overflow-y-auto, #QuickViewContent .overflow-auto');
          if (nestedScroller && nestedScroller !== content && nestedScroller.scrollHeight > nestedScroller.clientHeight) {
            return;
          }

          if (content.scrollHeight <= content.clientHeight) return;

          event.preventDefault();
          content.scrollTop += event.deltaY;
        };
        document.getElementById('QuickView')?.addEventListener('wheel', this._wheelHandler, { passive: false });
      },
      unbindScrollProxy() {
        if (!this._wheelHandler) return;
        document.getElementById('QuickView')?.removeEventListener('wheel', this._wheelHandler);
        this._wheelHandler = null;
      },
      focusQuickView(quickView, btnClose) {
        if ( !this.selected ) { 
          this.preservePageScroll();
          const content = this.getScrollContent();
          if (content) {
            content.focus({ preventScroll: true });
          }
          Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
          this.preservePageScroll();
          this.bindScrollProxy();
        }
      },
      removeFocusQuickView() {
        if ( !this.selected ) { 
          const elementActive = document.getElementById("button_quickview");
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },
      closePopupMobile() {
        this.openPopupMobile = false;
      },
      showChooseOption(id, el) {
        this.openPopupMobile = true;
        if (window.xViewport.innerWidth <= 767) {
          el.dispatchEvent(new Event('mouseover'));
        }
        const product = el.closest(".card-product");
        const addToCartBtn = product.querySelector('.choose-options')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product.querySelector('.choose-options')?.querySelector('.label-btn-quickview')
        const addToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.label-btn-quickview')

        if(addToCartBtn && iconAddToCartBtn && window.xViewport.innerWidth > 767){
          addToCartBtn.style.display="block"
          iconAddToCartBtn.style.display="none"
        }else if(addToCartBtnMobile && iconAddToCartBtnMobile){
          addToCartBtnMobile.style.display="block"     
          iconAddToCartBtnMobile.style.display="none"
        }
        document.dispatchEvent(new CustomEvent("eurus:quickview:open"));       
      },
      clickInsideQuickView(evt, $el) {
        if(this.isMiniCart) {
          evt.stopPropagation();
          this.show = false;
          Alpine.store('xPopup').close();
        }
      },
      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      }
    });
  });
});